export const SEND_TRIAL_EMAIL_ENDPOINT = '/send-trial-details';
export const SEND_TRIAL_LOGIN_ENDPOINT = '/send-trial-login-details';
